import {ajax} from '../utils/ajaxHelper';
import {log} from '../api/logger';

function getUserData() {
    const url = '/pdp/userData';

    return ajax(url)
        .then((response) => response)
        .catch((error) => {
            const errorMessage =
                (error && (error.response && error.response.body)) || error.message;
            log({
                error: `getUserData exception.  Error: ${errorMessage}`
            });
        });
}

export default getUserData;
export {getUserData};
